var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-skeleton-wrapper",
        {
          attrs: { loading: _vm.isArticleLoadInProgress },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "position-relative skeleton-image-wrapper" },
                    [
                      _c("b-skeleton-img", {
                        attrs: {
                          width: "100%",
                          height: "565px",
                          animation: "fade"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "skeleton-image-text-container w-100" },
                        [
                          _c("b-skeleton", {
                            staticClass: "w-75",
                            attrs: { animation: "fade" }
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "w-50",
                            attrs: { animation: "fade" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "container d-xl-flex d-block justify-content-center w-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "skeleton-question-and-rating" },
                        [
                          _c("b-skeleton", {
                            staticClass: "w-50 question-and-rating-text",
                            attrs: { animation: "fade" }
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "w-50 question-and-rating-text",
                            attrs: { animation: "fade" }
                          }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "w-75 question-and-rating-date",
                            attrs: { animation: "fade" }
                          }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c("b-skeleton", {
                            staticClass: "w-75 question-and-rating-stars",
                            attrs: { animation: "fade" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "question-and-rating-btn-wrapper" },
                            [
                              _c("b-skeleton", {
                                staticClass: "w-100 question-and-rating-btn",
                                attrs: { animation: "fade" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-100" },
                        [
                          _c("div", { staticClass: "my-3" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-center" },
                              [
                                _c("b-skeleton", {
                                  staticClass:
                                    "w-75 skeleton-content-large-text",
                                  attrs: { animation: "fade" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-center" },
                              [
                                _c("b-skeleton", {
                                  staticClass:
                                    "w-50 skeleton-content-large-text",
                                  attrs: { animation: "fade" }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(10, function(index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "mt-4 mb-4" },
                              [
                                _c("b-skeleton", {
                                  staticClass: "w-50",
                                  attrs: { animation: "fade" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "w-100",
                                  attrs: { animation: "fade" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "w-75",
                                  attrs: { animation: "fade" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "w-25",
                                  attrs: { animation: "fade" }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.article && !_vm.isArticleLoadInProgress
            ? [
                _c(
                  "div",
                  {
                    attrs: {
                      itemscope: "",
                      itemtype: "https://schema.org/Article"
                    }
                  },
                  [
                    _vm.article && _vm.article.imageSrc && _vm.article.showImage
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "article-image-container overlay" },
                            [
                              _c("img", {
                                staticClass: "w-100 h-100",
                                attrs: {
                                  src: _vm.article.imageSrc,
                                  alt: _vm.article.title
                                }
                              }),
                              _vm._v(" "),
                              _c("h1", {
                                staticClass: "container article-h1-title",
                                attrs: { itemprop: "name" },
                                domProps: {
                                  textContent: _vm._s(_vm.article.title)
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "articleSection",
                        content: _vm.article.metaData.articleSection
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "headline",
                        content: _vm.article.metaData.headline
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        attrs: {
                          itemprop: "publisher",
                          itemscope: "",
                          itemtype: "https://schema.org/Organization"
                        }
                      },
                      [
                        _c("meta", {
                          attrs: {
                            itemprop: "name",
                            content: _vm.article.metaData.publisherName
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: {
                              itemprop: "logo",
                              itemscope: "",
                              itemtype: "https://schema.org/ImageObject"
                            }
                          },
                          [
                            _c("meta", {
                              attrs: {
                                itemprop: "url",
                                content: _vm.article.metaData.publisherLogo
                              }
                            }),
                            _vm._v(" "),
                            _c("meta", {
                              attrs: { itemprop: "width", content: "171" }
                            }),
                            _vm._v(" "),
                            _c("meta", {
                              attrs: { itemprop: "height", content: "80" }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        attrs: {
                          itemprop: "image",
                          itemscope: "",
                          itemtype: "https://schema.org/ImageObject"
                        }
                      },
                      [
                        _c("meta", {
                          attrs: {
                            itemprop: "url",
                            content: _vm.article.metaData.ogImage
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: { itemprop: "width", content: "600" }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: { itemprop: "height", content: "314" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "mainEntityOfPage",
                        content: _vm.article.metaData.mainEntityOfPage
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "datePublished",
                        content: _vm.article.metaData.datePublished
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "dateModified",
                        content: _vm.article.metaData.dateModified
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 d-flex justify-content-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "article-text container",
                            style: _vm.article.showImage
                              ? ""
                              : "margin-top: 20px !important;"
                          },
                          [
                            !_vm.article.imageSrc || _vm.article.imageSrc === ""
                              ? _c("h1", {
                                  staticClass:
                                    "container article-h1-title text-center",
                                  attrs: { itemprop: "name" },
                                  domProps: {
                                    textContent: _vm._s(_vm.article.title)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "article-action-container" },
                              [
                                _vm.article.author
                                  ? _c("div", [
                                      _c("span", {
                                        staticClass: "author",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.article.author
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("meta", {
                                        attrs: {
                                          itemprop: "author",
                                          content: _vm.article.author
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.article.authorTitle
                                        ? _c("span", {
                                            staticClass: "author-job-title",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.article.authorTitle
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  : _c("meta", {
                                      attrs: {
                                        itemprop: "author",
                                        content: "unknown"
                                      }
                                    }),
                                _vm._v(" "),
                                _vm.article.hasPublicationDate
                                  ? _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.article.publicationDate
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.article.hasPublicationDate ||
                                _vm.article.author
                                  ? _c("hr")
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex d-xl-block" },
                                  [
                                    _vm.isLoggedIn
                                      ? _c("favorite-button", {
                                          staticClass: "fav-btn",
                                          attrs: {
                                            "item-id": parseInt(_vm.article.id),
                                            "item-type": "article",
                                            "is-background-visible": false
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("rating-stars", {
                                      staticClass: "mt-2",
                                      attrs: {
                                        rating: _vm.article.rating,
                                        "is-rating-enabled":
                                          _vm.isLoggedIn &&
                                          !_vm.article.userHasRate,
                                        "is-review-count-visible": false
                                      },
                                      on: { rateClicked: _vm.rateArticle }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.article.isCommentEnabled
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "kerdezek_tittle",
                                          expression: "'kerdezek_tittle'"
                                        }
                                      ],
                                      staticClass: "custom-button mt-3",
                                      attrs: { "data-cy": "write-question" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs[
                                            "comment-block"
                                          ].scrollIntoView({
                                            behavior: "smooth"
                                          })
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.article.lead
                              ? _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.article.lead)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "observe-visibility",
                                    rawName: "v-observe-visibility",
                                    value:
                                      _vm.textAndWidgetDisplayVisibilityChanged,
                                    expression:
                                      "textAndWidgetDisplayVisibilityChanged"
                                  }
                                ]
                              },
                              [
                                _vm.isTextAndWidgetDisplayVisible
                                  ? _c("text-and-widget-display", {
                                      staticClass: "article-body",
                                      attrs: { "text-body": _vm.article.body }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-wrap mt-2" },
                              [
                                _vm._l(_vm.article.childArticleList, function(
                                  articleData
                                ) {
                                  return _c("article-card", {
                                    key: articleData.id,
                                    staticClass: "col-12 col-md-6 my-2",
                                    attrs: {
                                      article: articleData,
                                      "is-overlay-type": true
                                    }
                                  })
                                }),
                                _vm._v(" "),
                                _vm.article.hasMoreChildArticle
                                  ? [
                                      _vm.isMoreChildArticlesLoading
                                        ? _c("loading-indicator")
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 d-flex align-items-center justify-content-center my-5"
                                            },
                                            [
                                              _c("span", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "others",
                                                    expression: "'others'"
                                                  }
                                                ],
                                                staticClass:
                                                  "cursor-pointer load-more-btn",
                                                on: {
                                                  click:
                                                    _vm.loadMoreChildArticles
                                                }
                                              })
                                            ]
                                          )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-4" }, [
                              _c("div", {
                                staticClass: "parent-title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.article.parentArticleName
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "article-title",
                                domProps: {
                                  textContent: _vm._s(_vm.article.title)
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.article.author
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mb-4 d-flex justify-content-between author-box"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _c("b-avatar", {
                                          attrs: {
                                            text: _vm.getAuthorInitial()
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ml-4 d-flex justify-content-center flex-column"
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "author",
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.article.author
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.article.authorTitle
                                              ? _c("div", {
                                                  staticClass:
                                                    "author-job-title",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.article.authorTitle
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.article.showRecommendations
                              ? _c("div", { staticClass: "my-4" }, [
                                  _vm.article.similarArticleList.length > 0
                                    ? _c("div", [
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "kapcsolodo_cikkek_label",
                                              expression:
                                                "'kapcsolodo_cikkek_label'"
                                            }
                                          ],
                                          staticClass:
                                            "article-bar-title my-4 col-12 text-center"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-wrap" },
                                          _vm._l(
                                            _vm.article.similarArticleList,
                                            function(currentArticle) {
                                              return _c("article-card", {
                                                key: currentArticle.id,
                                                staticClass:
                                                  "col-12 col-md-6 my-2",
                                                attrs: {
                                                  article: currentArticle,
                                                  "is-overlay-type": true
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c("div", {
                                            directives: [
                                              {
                                                name: "t",
                                                rawName: "v-t",
                                                value: "top_articles",
                                                expression: "'top_articles'"
                                              }
                                            ],
                                            staticClass: "text-center my-4"
                                          }),
                                          _vm._v(" "),
                                          _c("article-bar", {
                                            attrs: {
                                              type: "TOPLIST",
                                              limit: 8,
                                              "skip-article-id": _vm.article.id
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.article.isCommentEnabled
                              ? _c(
                                  "div",
                                  { ref: "comment-block" },
                                  [
                                    _vm.unAnsweredCommentList.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c("div", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "kerdesed_valaszra_var_article",
                                                  expression:
                                                    "'kerdesed_valaszra_var_article'"
                                                }
                                              ],
                                              staticClass:
                                                "text-center font-weight-bold"
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.unAnsweredCommentList,
                                              function(comment) {
                                                return _c("comment-card", {
                                                  key: comment.id,
                                                  staticClass: "my-3",
                                                  attrs: {
                                                    comment: comment,
                                                    "data-cy": "comment-card"
                                                  }
                                                })
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "legy_turelemmel_kerdes_article",
                                                  expression:
                                                    "'legy_turelemmel_kerdes_article'"
                                                }
                                              ],
                                              staticClass:
                                                "text-center font-weight-bold",
                                              attrs: {
                                                "data-cy": "be-patient-text"
                                              }
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.unAnsweredCommentList.length === 0
                                      ? _c(
                                          "div",
                                          { staticClass: "my-4" },
                                          [
                                            _vm.article.canSendQuestion
                                              ? [
                                                  !_vm.isLoggedIn
                                                    ? _c("custom-input", {
                                                        attrs: {
                                                          "title-name": _vm.$t(
                                                            "helpdesk_emailcim"
                                                          ),
                                                          "error-text":
                                                            _vm.errorMsg,
                                                          "has-error":
                                                            _vm.errorMsg,
                                                          "data-cy":
                                                            "article-question-email-input"
                                                        },
                                                        model: {
                                                          value: _vm.email,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.email = $$v
                                                          },
                                                          expression: "email"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.questionText,
                                                        expression:
                                                          "questionText"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "term_kerdesek_irdmegaboxban_article"
                                                      ),
                                                      "data-cy":
                                                        "question-textarea"
                                                    },
                                                    domProps: {
                                                      value: _vm.questionText
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.questionText =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-center"
                                                    },
                                                    [
                                                      _c("button", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "term_kerdesek_elkuld",
                                                            expression:
                                                              "'term_kerdesek_elkuld'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "custom-button my-3",
                                                        attrs: {
                                                          disabled:
                                                            _vm.questionText
                                                              .length < 15 ||
                                                            _vm.isSendingQuestion,
                                                          "data-cy":
                                                            "send-question-btn"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.sendQuestion
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : _c("div", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value:
                                                        "nincs_lehetoseg_tobb_kerdesre",
                                                      expression:
                                                        "'nincs_lehetoseg_tobb_kerdesre'"
                                                    }
                                                  ],
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    "data-cy":
                                                      "no-option-for-recive-answer-text"
                                                  }
                                                })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.answeredCommentList, function(
                                      comment
                                    ) {
                                      return _c("comment-card", {
                                        key: comment.id,
                                        staticClass: "my-3",
                                        attrs: { comment: comment }
                                      })
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }